<div class="portal-table-card">
  <div class="portal-table__toolbar">
    <ng-content select="[portalTableToolbar]"></ng-content>
  </div>

  <div
    class="portal-table__header"
    [style.grid-template-columns]="gridTemplateColumns">
    <button
      *ngFor="let column of columns; trackBy: trackByColumn"
      type="button"
      class="portal-table__header-cell"
      [ngClass]="headerClass(column)"
      [class.portal-table__header-cell--sortable]="column.sortable"
      [class.portal-table__header-cell--active]="sortActive === column.key"
      [disabled]="!column.sortable"
      (click)="toggleSort(column)">
      <span>{{ column.label }}</span>
      <mat-icon *ngIf="column.sortable">{{ sortIcon(column) }}</mat-icon>
    </button>
  </div>

  <div class="portal-table__body">
    <ng-container *ngIf="loading; else loadedRows">
      <div
        class="portal-table__row portal-table__row--loading"
        *ngFor="let row of skeletonRows; trackBy: trackByIndex"
        [style.grid-template-columns]="gridTemplateColumns">
        <span
          class="portal-table__cell"
          *ngFor="let column of columns; trackBy: trackByColumn">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              width: '88%',
              height: '22px',
              marginBottom: '0',
              borderRadius: '8px'
            }"></ngx-skeleton-loader>
        </span>
      </div>
    </ng-container>

    <ng-template #loadedRows>
      <div
        class="portal-table__row"
        *ngFor="let row of rows; trackBy: trackByRow"
        [attr.role]="rowClickable ? 'button' : null"
        [attr.tabindex]="rowClickable ? 0 : null"
        [class.portal-table__row--clickable]="rowClickable"
        [style.grid-template-columns]="gridTemplateColumns"
        (click)="emitRowClick(row)"
        (keydown)="onRowKeydown($event, row)">
        <span
          class="portal-table__cell"
          *ngFor="let column of columns; trackBy: trackByColumn"
          [ngClass]="cellClass(column)">
          <ng-container *ngIf="templateFor(column.key) as cellTemplate; else defaultCell">
            <ng-container
              *ngTemplateOutlet="cellTemplate.template; context: { $implicit: row, column: column }">
            </ng-container>
          </ng-container>
          <ng-template #defaultCell>{{ cellValue(row, column) }}</ng-template>
        </span>
      </div>

      <div class="portal-table__empty" *ngIf="!rows.length">
        <strong>{{ emptyTitle }}</strong>
        <span *ngIf="emptyDescription">{{ emptyDescription }}</span>
        <button
          *ngIf="emptyActionLabel"
          type="button"
          class="portal-table__empty-action"
          (click)="emptyAction.emit()">
          {{ emptyActionLabel }}
        </button>
      </div>
    </ng-template>
  </div>

  <div class="portal-table__footer">
    <ng-content select="[portalTableFooter]"></ng-content>
  </div>
</div>
